import { Box, BoxProps } from "@mui/material"
import { theme } from "src/providers/ThemeProvider"

interface ICommonContainerProps
  extends React.PropsWithChildren<unknown>,
    BoxProps {
  bannerProps?: {
    src: string
    alt: string
  }
}

const CommonContainer = ({
  children,
  width = 600,
  height = "auto",
  bannerProps,
  sx,
  ...rest
}: ICommonContainerProps) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      border={`solid 5px ${theme.palette.success.main}`}
      bgcolor="white"
      width={width}
      height={height}
      position="relative"
      borderRadius={3}
      sx={{
        [theme.breakpoints.down(600)]: {
          width: "100%",
        },
        padding: theme.spacing(5, 0),
        ...{ ...sx },
      }}
      {...rest}
    >
      {bannerProps && (
        <Box
          top={-45}
          sx={{
            [theme.breakpoints.down(600)]: {
              top: -35,
              "& > img": {
                width: "85%",
              },
            },
            [theme.breakpoints.down(500)]: {
              top: -25,
            },
          }}
          position="absolute"
          textAlign="center"
        >
          <img src={bannerProps.src} alt={bannerProps.alt} />
        </Box>
      )}
      {children}
    </Box>
  )
}
export default CommonContainer
